import React from 'react'
import './PropertySalesComp.scss'
import PropTypes from 'prop-types'
import { PropertyImage, PropertyInfo, UnitMix, Notes } from '@components/custom'
import { ReactComponent as SummaryLogo } from '@src/assets/summary_right_logo.svg'
import { SALES_COMPS_PAGE_TITLE } from '@engine/dependencies/constants'
import { connect } from 'react-redux'
import Comps from '@engine/comps'

export class PropertySalesComp extends React.Component {

  editPropertyNotes = (n, propertyType) => {
    const updatedProperty = this.props.propertyInfoData.find(obj => obj.propertyType === propertyType)
    const { propertyData } = updatedProperty
    this.props.editFeature({ ...propertyData, 'sourceNote': n })
  }

  createSalesPropertyDiv = (summaryProp, templateName, templateSettings) => (
    <div key={summaryProp.name} className="property-container">
      <div className="sales-property" id={`#property_${summaryProp.propertyType}`}>
        <PropertyImage propertyType={summaryProp.propertyType} imageUrl={summaryProp.signedUrl || ''} templateName={templateName} />
        <PropertyInfo propertyInfo={summaryProp.propertyData} templateName={templateName} notesLimit={612} propertyType={summaryProp.propertyType} propertyNameList={this.props.propertyNameList}/>
        {this.props.hasSourceNotes && <div className="notes-section">
          <Notes
            notesContent={summaryProp.propertyData.sourceNote}
            templateType={templateSettings.templateType}
            notesLimit={templateSettings.sourceNotesCount}
            updateNotes={n => this.editPropertyNotes(n, summaryProp.propertyType)}
            propertyType={summaryProp.propertyType}
            themeColors={templateSettings.themeColors}
            propertyLabel={`salesnotes${summaryProp.propertyType}`}
          />
        </div>}
        {this.props.hasUnitMix &&
          <UnitMix
            comparableData={summaryProp.comparableData}
            unitMixPercantage={summaryProp.chartData}
            unitMixCount={templateSettings.unitMixCount}
            propertyType={summaryProp.propertyType}
          />
        }
      </div>
    </div>
  )

  divideSalesPropToBlocks = (propertyInfoData, templateName, templateSettings) => {
    let fprop = []
    const final = []
    propertyInfoData.forEach((summaryProp, index) => {
      if (summaryProp.propertyType === 'NA') {
        return
      }
      if (index === 0 || index % 4 !== 0) {
        fprop.push(this.createSalesPropertyDiv(summaryProp, templateName, templateSettings))
      } else {
        final.push([...fprop])
        fprop = []
        fprop.push(this.createSalesPropertyDiv(summaryProp, templateName, templateSettings))
      }
    })

    final.push([...fprop])

    return final
  }

  render() {
    const {
      propertyInfoData,
      templateName,
      hasBranding,
      hasPageTitle,
      templateDataLimits: { sourceNotesCount, unitMixCount },
      templateType,
      themeColors
    } = this.props
    const templateSettings = { sourceNotesCount, templateType, themeColors, unitMixCount }
    const data = this.divideSalesPropToBlocks(propertyInfoData, templateName, templateSettings)

    return (
      <React.Fragment>
        {
          data.map((row, index) => (
            <div key={index} data-testid={`property-sales-comps${index}`} className={(!hasBranding && !hasPageTitle) ? 'property-sales-comps-view sale-no-margin' : 'property-sales-comps-view' }>

              <div className={(!hasBranding && !hasPageTitle) ? 'hide-summary-header' : 'summary-header' }>
                <span className="prop_sales_header" style={{ color: themeColors.globalSubColor }}>
                  {hasPageTitle && SALES_COMPS_PAGE_TITLE}
                </span>
                {hasBranding &&
                  <SummaryLogo data-testid="logo-long" className="summary_logo" />
                }
              </div>
              <div className="sales-props-four">
                {(row.map(col => (
                  col
                )))}
              </div>
            </div>
          ))
        }
      </React.Fragment>
    )
  }
}

PropertySalesComp.propTypes = {
  hasSourceNotes: PropTypes.bool,
  hasBranding: PropTypes.bool,
  hasPageTitle: PropTypes.bool,
  hasUnitMix: PropTypes.bool,
  propertyInfoData: PropTypes.array,
  templateName: PropTypes.string,
  templateDataLimits: PropTypes.shape({
    unitMixCount: PropTypes.number,
    amenitiesCount: PropTypes.number,
    sourceNotesCount: PropTypes.number
  }),
  templateType: PropTypes.string,
  editFeature: PropTypes.func,
  themeColors: PropTypes.object,
  propertyNameList: PropTypes.array
}

const mapStateToProps = state => ({
  templateDataLimits: Comps.selectors.comps.templateDataLimits(state),
  themeColors: Comps.selectors.comps.themeColors(state)
})

export default connect(mapStateToProps)(PropertySalesComp)
